import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Quotation } from 'src/app/shared/models/quotation.model';
import { LanguageService } from 'src/app/shared/services/language.service';
import { environment } from 'src/environments/environment';

enum EndpointRoutes {
  CREATE_QUOTATION = 'quotation/create',
}

@Injectable({
  providedIn: 'root'
})
export class QuotationService {

  constructor(private http: HttpClient, private languageService: LanguageService) {
  }

  public create(quotation: Quotation) {
    if (!environment.production) {
      console.log('quotation', quotation);
    }
    quotation.lang = this.languageService.currentLanguage();
    return this.http.post(environment.apiUrl + EndpointRoutes.CREATE_QUOTATION, { quotation: quotation });
  }

}
